import React from 'react';
import { PropTypes } from 'prop-types';
import './TermsLimitationsModal.scss';
import { Modal } from 'react-bootstrap';

function TermsLimitationText({ disclaimerArray }) {
  return (
    <>
      <Modal.Body>
        <Modal.Header
          closeButton
          className="GA4_CTA"
          cta_type="Pharmacy Incentives"
        />

        {disclaimerArray &&
          disclaimerArray.map((disclaimerArrayobj) => (
            <React.Fragment key={disclaimerArrayobj.disclaimerHeader}>
              {' '}
              <Modal.Title>
                <div className="offer-badge-text-terms">
                  <p>{disclaimerArrayobj.disclaimerHeader}</p>
                </div>
              </Modal.Title>
              <h1 className="sub-title-disclaimer poppinsFont">Disclaimer</h1>
              <p className="albertson-pharmacy">
                {disclaimerArrayobj.disclaimerText}
              </p>
            </React.Fragment>
          ))}
      </Modal.Body>
    </>
  );
}
TermsLimitationText.propTypes = {
  disclaimerArray: PropTypes.any,
};

export default TermsLimitationText;
